import type { CSSObject } from "@emotion/react";

import { theme } from "@/theme/theme";

export type ButtononHoverVariant =
  | "gradient-flip"
  | "color-reverse"
  | "color-lighten-pink"
  | "color-lighten-green"
  | "fade-out"
  | "default-icon"
  | "default";
export type ButtonVariant =
  | "primary"
  | "secondary"
  | "text"
  | "outlined"
  | "rounded"
  | "default";

export const getOnHoverCss = (
  onHoverVariant: ButtononHoverVariant,
  variant?: ButtonVariant,
): CSSObject => {
  // if (variant === "text") {
  //   return {};
  // }

  switch (onHoverVariant) {
    case "gradient-flip":
      return {
        "&:hover": {
          animation: "moveBackground 0.2s linear forwards",
        },
        "&:not(&:hover)": {
          animation: "moveBackgroundBack 0.2s forwards",
        },
        "@keyframes moveBackground": {
          from: {
            backgroundPosition: "0 0",
          },
          to: {
            backgroundPosition: "100% 0",
          },
        },
        "@keyframes moveBackgroundBack": {
          from: {
            backgroundPosition: "100% 0",
          },
          to: {
            backgroundPosition: "0 0",
          },
        },
      };
    case "color-reverse":
      if (variant === "secondary") {
        return {
          transition: "all 0.1s ease-in-out !important",

          "&:hover": {
            backgroundImage: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.green.main}, ${theme.palette.primary.main})`,
            color: theme.palette.secondary.main,
            " path": {
              fill: theme.palette.white.main,
            },
          },
        };
      } else {
        return {
          transition: "all 0.1s ease-in-out !important",

          "&:hover": {
            backgroundColor: theme.palette.white.main,
            backgroundImage: "unset",
            color: theme.palette.green.main,
          },
        };
      }
    case "color-lighten-pink":
      return {
        "&:hover": {
          backgroundImage:
            "linear-gradient(to right, #fec9d6, #fc678e, #fb3c6e)",
          color: theme.palette.white.main,
        },
      };
    case "color-lighten-green":
      return {
        "&:hover": {
          backgroundImage:
            "linear-gradient(to right, #74dade, #5fdbac, #69dac3)",
          color: theme.palette.white.main,
        },
      };
    case "fade-out":
      return {
        transition: "opacity 0.2s ease-in-out",
        "&:hover": {
          opacity: 0.8,
        },
      };
    case "default-icon":
      if (variant === "secondary") {
        return {
          transition: "all 0.1s ease-in-out !important",
          "&:hover": {
            backgroundImage: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.green.main}, ${theme.palette.primary.main})`,
            color: theme.palette.secondary.main,
          },
        };
      } else {
        return {
          transition: "all 0.1s ease-in-out !important",

          "&:hover": {
            backgroundColor: theme.palette.white.main,
            backgroundImage: "unset",
            color: theme.palette.green.main,
          },
        };
      }
    default:
      return {};
  }
};
